function parseCardBrandImageUrl(card) {
  // eslint-disable-next-line no-undef
  return `//${window.location.hostname}:${window.location.port}/cards/${card.brand}.png`;
}

const PaymentType = {
  CARD: 'card',
  WALLET: 'wallet',
  PIX: 'pix',
};

const WalletType = {
  GOOGLE_PAY: 'google_pay',
  APPLE_PAY: 'apple_pay',
};

export { PaymentType, WalletType, parseCardBrandImageUrl };
